/* Read published Judge.me reviews without copying records or changing product ratings. */
(() => {
  const node = (tag, value, className) => {
    const element = document.createElement(tag);
    element.textContent = value;
    if (className) element.className = className;
    return element;
  };
  function productPath(value) {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin && /^\/products\/[^/]+\/?$/.test(url.pathname) ? url.pathname.replace(/\/$/, '') : null;
    } catch { return null; }
  }
  function imageUrl(value) {
    try {
      const url = new URL(value);
      return url.protocol === 'https:' ? url.href : null;
    } catch { return null; }
  }
  function reviewerName(review) {
    if (review.is_anonymous_reviewer) return 'Anonymous';
    const name = String(review.reviewer_name || 'Customer');
    if (!window.jdgmSettings) return String(review.reviewer_initial || 'Customer');
    const format = window.jdgmSettings.widget_reviewer_name_as_initial || '';
    const words = name.trim().split(/\s+/);
    if (!format) return name;
    if (format === 'last_initial') return words.length > 1 ? words.slice(0, -1).join(' ') + ' ' + words.at(-1)[0] + '.' : name;
    if (format === 'all_initials') return words.map(word => word[0] + '.').join(' ');
    return String(review.reviewer_initial || 'Customer');
  }
  function init(host) {
    if (host.dataset.ready) return;
    host.dataset.ready = 'true';
    let data;
    try { data = JSON.parse(host.querySelector('[data-review-family-data]').textContent); } catch { return; }
    if (!/^[a-z0-9-]+\.myshopify\.com$/.test(data.shop)) return;
    const family = new Set(Array.isArray(data.products) ? data.products.map(productPath).filter(Boolean) : []);
    const dialog = host.querySelector('dialog');
    let photoTrigger;
    host.addEventListener('click', event => {
      const photo = event.target.closest('[data-review-photo]');
      if (!photo) return;
      photoTrigger = photo;
      dialog.querySelector('img').src = photo.dataset.reviewPhoto;
      dialog.showModal();
    });
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => { dialog.querySelector('img').removeAttribute('src'); photoTrigger?.focus(); });
    const requests = new Map();
    function pageData(page) {
      if (!requests.has(page)) {
        // shortcut: this published storefront feed is shared with Judge.me; revalidate on provider widget upgrades.
        const url = new URL('https://cdn.judge.me/reviews/all_reviews_js_based');
        url.search = new URLSearchParams({widget_type:'review-widget', page:String(page), review_type:'product-reviews', sort_by:'created_at', sort_dir:'desc', widget_theme:'standard', shop_domain:data.shop, platform:'shopify'});
        requests.set(page, fetch(url, {credentials:'omit', signal:AbortSignal.timeout(12000)}).then(async response => {
          if (!response.ok) throw new Error('Reviews unavailable');
          const result = await response.json();
          if (!Array.isArray(result.reviews) || !Number.isInteger(result.pagination?.total_pages) || result.pagination.total_pages < 0 || Number(result.pagination.current_page) !== page) throw new Error('Invalid review response');
          return result;
        }).catch(error => { requests.delete(page); throw error; }));
      }
      return requests.get(page);
    }
    function renderReview(review) {
      const card = node('article', '', 'review-scope__item');
      card.dataset.reviewUuid = review.uuid;
      const heading = node('div', '', 'review-scope__reviewer');
      const stars = node('span', '★'.repeat(review.rating) + '☆'.repeat(5-review.rating), 'review-scope__stars');
      stars.setAttribute('aria-label', review.rating + ' out of 5 stars');
      heading.append(stars, node('strong', reviewerName(review)));
      if (review.verified_buyer === true) heading.append(node('span', 'Verified buyer', 'review-scope__verified'));
      card.append(heading);
      const path = productPath(review.product_url);
      const product = node(path && review.product_in_store !== false ? 'a' : 'span', 'Review for: ' + (review.product_title || 'Product no longer available'), 'review-scope__product');
      if (product.tagName === 'A') product.href = path;
      card.append(product);
      if (review.title) card.append(node('h4', review.title));
      const text = String(review.body || '');
      if (text.length > 300) {
        const details = node('details', '', 'review-scope__text');
        details.append(node('summary', 'Read full review'), node('p', text));
        card.append(node('p', text.slice(0,300).trimEnd() + '…', 'review-scope__excerpt'), details);
      } else if (text) card.append(node('p', text));
      const photos = node('div', '', 'review-scope__photos');
      for (const picture of Array.isArray(review.pictures_urls) ? review.pictures_urls : []) {
        const full = imageUrl(typeof picture === 'string' ? picture : picture.original || picture.huge);
        const thumb = imageUrl(typeof picture === 'string' ? picture : picture.compact || picture.small || picture.huge || picture.original);
        if (!full || !thumb) continue;
        const button = node('button', '');
        button.type = 'button'; button.dataset.reviewPhoto = full;
        button.setAttribute('aria-label', 'View photo from this review');
        const image = document.createElement('img');
        image.src = thumb; image.alt = 'Customer photo'; image.loading = 'lazy'; image.width = 96; image.height = 96;
        image.addEventListener('error', () => button.remove(), {once:true});
        button.append(image); photos.append(button);
      }
      if (photos.children.length) card.append(photos);
      if (review.video_external_ids?.length || review.media_platform_hosted_video_infos?.length) {
        if (path) { const link = node('a', 'View video in the original product review'); link.href = path + '#judgeme_product_reviews'; card.append(link); }
      }
      if (review.reply_content) {
        const reply = node('div', '', 'review-scope__reply');
        reply.append(node('strong', '3D Heirloom replied'), node('p', review.reply_content));
        card.append(reply);
      }
      return card;
    }
    host.querySelectorAll('[data-review-feed]').forEach(panel => {
      const isFamily = panel.dataset.reviewFeed === 'family';
      if (isFamily && (!data.complete || !family.size || !data.family || ![...family].some(path => path !== data.current))) { panel.hidden = true; return; }
      const list = panel.querySelector('[data-review-feed-list]');
      const status = panel.querySelector('[data-review-feed-status]');
      const more = panel.querySelector('[data-review-feed-more]');
      let next = 1, pages = 1, busy = false, initialized = false;
      const seen = new Set(), pending = [];
      async function load() {
        if (busy) return;
        busy = true; more.disabled = true; status.textContent = 'Loading reviews…'; list.setAttribute('aria-busy','true');
        try {
          // Scan at most three pages per click, so sparse series never cause an unbounded download.
          let scanned = 0;
          while (pending.length < 5 && next <= pages && scanned < 3) {
            const result = await pageData(next);
            pages = result.pagination.total_pages;
            for (const review of result.reviews) {
              if (!review || review.is_shop_review !== false || review.hidden === true || review.published === false || typeof review.uuid !== 'string' || seen.has(review.uuid)) continue;
              if (!Number.isInteger(review.rating) || review.rating < 1 || review.rating > 5) continue;
              const path = productPath(review.product_url);
              if (isFamily && (!family.has(path) || path === data.current)) continue;
              seen.add(review.uuid); pending.push(review);
            }
            if (!isFamily && Number.isInteger(result.number_of_product_reviews)) panel.querySelector('[data-review-feed-count]').textContent = ' (' + result.number_of_product_reviews + ')';
            next++; scanned++;
          }
          pending.splice(0,5).forEach(review => list.append(renderReview(review)));
          const finished = next > pages && !pending.length;
          status.textContent = list.children.length ? '' : finished ? (isFamily ? 'No reviews for other products in this series yet.' : 'No product reviews yet.') : 'Continue to look for reviews from other products in this series.';
          more.hidden = finished;
          more.textContent = isFamily ? 'Show more from this series' : 'Show more product reviews';
          initialized = true;
        } catch {
          status.textContent = 'Reviews could not be loaded. Please try again.';
          more.hidden = false; more.textContent = 'Try again';
        } finally {
          busy = false; more.disabled = false; list.removeAttribute('aria-busy');
        }
      }
      panel.addEventListener('toggle', () => {
        if (!panel.open) return;
        host.querySelectorAll('[data-review-feed]').forEach(other => { if (other !== panel) other.open = false; });
        if (!initialized) load();
      });
      more.addEventListener('click', load);
    });
  }
  const scan = root => root.querySelectorAll('[data-review-scopes]').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
